const escapeHtml = require('stringify-entities').escape;

const enqueteCommand = require('./command/enquete');

const commandMatcher = /{([a-z_]+)\.([a-z_]+)\(([^)]*)\)}/i;

const command = {};
command.monsterstrike = {};
command.shironeko_project = {};
command.mhxx = {};
command.fgo = {};
command.azurlane = {};
command.usum = {};
command.general = {
  ...enqueteCommand,
};
command.hearthstone = {};
command.letsgo = {};
command.brodus = {};
command.teppen = {};
command.mhrise = {};
command.umamusume = {};
command.dbd = {};
command.bdsp = {};
command.sv = {};
command.legendsarceus = {};
command.masterduel = {};
command.duellinks = {};
command.eldenring = {};
command.dokkan_battle = {};
command.pawapuro = {};
command.ARK = {};
command.genshin = {};
command.pad = {};
command.mhnow = {};
command.palworld = {};
command.mhwilds = {};

command.monsterstrike.ss_voice_button = (_, str, id) => {
  return `<table><tr><th class="strikeshot_word">セリフ</th><td class="strikeshot_word">${escapeHtml(str)}</td><td class="strikeshot_audio"><button class="playSound" data-id="${escapeHtml(id)}">ボイスを聴く</button></td></tr></table>`;
};

command.fgo.radar_chart = (_, ...args) => {
  return `<div class="fgo_radar_chart"><canvas data-values="${escapeHtml(JSON.stringify(args))}"></canvas></div>`;
};

command.azurlane.radar_chart = (_, ...args) => {
  return `<div class="azurlane_radar_chart"><canvas data-values="${escapeHtml(JSON.stringify(args))}"></canvas></div>`;
};

command.azurlane.gacha_simulator = (_, type) => {
  return `<div class="azurlane_gacha_simulator" id="gacha_wrapper" data-type="${escapeHtml(type)}"></div>`;
};

command.hearthstone.deck_code_form = (state, code) => {
  const codeId = `${code.replace(/[^a-zA-Z0-9_]+/g, '')}_${state.line}`;

  return `<div class="hearthstone_deck_code_form"><p><input id="${escapeHtml(codeId)}" value="${escapeHtml(code)}"></p><p><span class="button_navigation"><button class="copy-clipboard" data-clipboard-target="#${escapeHtml(codeId)}">デッキコードをコピーする</button></span></p></div>`;
};

command.teppen.deck_code_form = (state, code) => {
  const codeId = `${code.replace(/[^a-zA-Z0-9_]+/g, '')}_${state.line}`;

  return `<div class="teppen_deck_code_form"><p><input id="${escapeHtml(codeId)}" value="${escapeHtml(code)}"></p><p><span class="button_navigation"><button class="copy-clipboard" data-clipboard-target="#${escapeHtml(codeId)}">デッキコードをコピーする</button></span></p></div>`;
};

command.umamusume.event_checker = (state) => {
  state.md.helperScripts.add('https://kamigame.jp/vls-kamigame-gametool/js/umamusume-event-checker.js');

  return '<div id="umamusume-event-checker"></div>';
};

command.umamusume.deck_simulator = (state) => {
  state.md.helperScripts.add('https://kamigame.jp/vls-kamigame-gametool/js/umamusume-deck-simulator.js');

  return '<div id="umamusume-deck-simulator"></div>';
};

command.umamusume.music_calculator = (state) => {
  state.md.helperScripts.add(
    'https://kamigame.jp/vls-kamigame-gametool/js/umamusume/music-calculator/main.js'
  );

  return '<div id="umamusume-music-calculator"></div>';
};

command.umamusume.rotation = (state) => {
  state.md.helperScripts.add('https://kamigame.jp/vls-kamigame-gametool/js/umamusume/rotation/main.js');

  return '<div id="umamusume-rotation"></div>';
};

command.umamusume.course_chart = (state, id) => {
  state.md.helperScripts.add('https://kamigame.jp/vls-kamigame-gametool/js/umamusume-course-chart.js');
  return `<div class="umamusume-course-chart" data-course-id="${escapeHtml(id)}"></div>`;
};

command.dbd.perk_roulette = (state, role) => {
  state.md.helperScripts.add('https://kamigame.jp/vls-kamigame-gametool/js/dbd-roulette-tool/app.js');

  return `
  <div class="dbd-roulette-tool-perk-roulette" data-target-role="${escapeHtml(role)}"></div>
  <link href="https://kamigame.jp/vls-kamigame-gametool/js/dbd-roulette-tool/app.css" rel="stylesheet" />
  `;
};

command.dbd.killer_roulette = (state) => {
  state.md.helperScripts.add('https://kamigame.jp/vls-kamigame-gametool/js/dbd-roulette-tool/app.js');

  return `
  <div id="dbd-roulette-tool-killer-roulette"></div>
  <link href="https://kamigame.jp/vls-kamigame-gametool/js/dbd-roulette-tool/app.css" rel="stylesheet" />
  `;
};

command.bdsp.egg_move_simulator = (state) => {
  state.md.helperScripts.add('https://kamigame.jp/vls-kamigame-gametool/js/pokemon-bdsp-egg-move-simulator/app.js');

  return `
  <div class="pokemon-bdsp-egg-move-simulator"></div>
  <link href="https://kamigame.jp/vls-kamigame-gametool/js/pokemon-bdsp-egg-move-simulator/app.css" rel="stylesheet" />
  `;
};

command.sv.egg_move_simulator = (state) => {
  state.md.helperScripts.add('https://kamigame.jp/vls-kamigame-gametool/js/pokemon-sv-egg-move-simulator/app.js');

  return '<div class="pokemon-sv-egg-move-simulator"></div>';
};

command.sv.move_search = (state) => {
  state.md.helperScripts.add('https://kamigame.jp/vls-kamigame-gametool/js/pokemon-sv/move-search/pokemon-sv-move-search.js');

  return '<div class="pokemon-sv-move-search"></div>';
};

command.sv.type_checker = (state) => {
  state.md.helperScripts.add('https://kamigame.jp/vls-kamigame-gametool/js/pokemon-sv/type-checker/pokemon-sv-type-checker.js');

  return '<div class="pokemon-sv-type-checker"></div>';
};

command.legendsarceus.move_pokemon_search = (state) => {
  state.md.helperScripts.add('https://kamigame.jp/vls-kamigame-gametool/js/legends-arceus-move-search/app.js');

  return `
  <div class="legends-arceus-move-search"></div>
  <link href="https://kamigame.jp/vls-kamigame-gametool/js/legends-arceus-move-search/app.css" rel="stylesheet" />
  `;
};

command.legendsarceus.task_checker = (state) => {
  state.md.helperScripts.add('https://kamigame.jp/vls-kamigame-gametool/js/legends-arceus-task-checker/app.js');

  return `
  <div class="legends-arceus-task-checker"></div>
  <link href="https://kamigame.jp/vls-kamigame-gametool/js/legends-arceus-task-checker/app.css" rel="stylesheet" />
  `;
};

command.masterduel.pack_search = (state) => {
  state.md.helperScripts.add('https://kamigame.jp/vls-kamigame-gametool/js/masterduel-pack-search/app.js');

  return `
  <div class="masterduel-pack-search"></div>
  <link href="https://kamigame.jp/vls-kamigame-gametool/js/masterduel-pack-search/app.css" rel="stylesheet" />
  `;
};

command.duellinks.pack_search = (state) => {
  state.md.helperScripts.add('https://kamigame.jp/vls-kamigame-gametool/js/duellinks-pack-search/app.js');

  return `
  <div class="duellinks-pack-search"></div>
  <link href="https://kamigame.jp/vls-kamigame-gametool/js/duellinks-pack-search/app.css" rel="stylesheet" />
  `;
};

command.pawapuro.event_checker = (state, key) => {
  state.md.helperScripts.add('https://kamigame.jp/vls-kamigame-gametool/js/pawapuro2022/event-checker/pawapuro-event-checker.js');

  return `<div class="pawapuro-event-checker" data-resource_key="${escapeHtml(key)}"></div>`;
};

command.pawapuro.keikenten_calculator = (state) => {
  state.md.helperScripts.add('https://kamigame.jp/vls-kamigame-gametool/js/pawapuro2022/keikenten-calculator/js/pawapuro-keikenten-calculator.js');

  return '<div id="pawapuro-keikenten-calculator"></div>';
};

command.ARK.taming_calc = (state, creature) => {
  state.md.helperScripts.add('https://kamigame.jp/vls-kamigame-gametool/js/ARK/taming-calc/taming-calc.js');

  return '<div class="ark-taming-calc"></div>';
};

command.ARK.taming_calc_with_creature = (state, creature) => {
  state.md.helperScripts.add('https://kamigame.jp/vls-kamigame-gametool/js/ARK/taming-calc/taming-calc.js');

  return `<div class="ark-taming-calc" data-creature="${escapeHtml(creature)}"></div>`;
};

command.ARK.iv_determination = (state, D, C, B, A, S, SS) => {
  state.md.helperScripts.add('https://kamigame.jp/vls-kamigame-gametool/js/ARK/iv-determination/iv-determination.js');

  const valuations = JSON.stringify({ D, C, B, A, S, SS });
  return `<div id="ark-iv-determination" data-valuations="${escapeHtml(valuations)}"></div>`;
};

command.genshin.event_checker = (state) => {
  state.md.helperScripts.add('https://kamigame.jp/vls-kamigame-gametool/js/genshin/event-checker/event-checker.js');

  return '<div id="genshin-event-checker"></div>';
};

command.genshin.relics_score = (state) => {
  state.md.helperScripts.add('https://kamigame.jp/vls-kamigame-gametool/js/genshin/relics-score/relics-score.js');

  return '<div id="genshin-relics-score"></div>';
};

command.general.append_helper_script = (state, url) => {
  const ALLOWED_PREFIXES = ['https://kamigame.jp/vls-kamigame-gametool/js/'];
  if (!ALLOWED_PREFIXES.some((p) => url.startsWith(p)) || !url.endsWith('.js')) {
    return '';
  }

  state.md.helperScripts.add(url);

  // NOTE: 空文字 (falsy な値) を返すと記法が除去されないのでコメントアウトを返す
  return `<!-- ${escapeHtml(url)} was appended to HelperScript. -->`;
};

command.general.functional_icon = (
  _,
  mainClass,
  size,
  altText,
  backgroundClass,
  badgeLeftClass,
  badgeLeftText,
  badgeRightClass,
  badgeRightText,
  labelBottomClass,
  labelBottomText,
  imageURL,
  url
) => {
  const baseClassStr = size === 'large' || size === 'small' ? `functional-icon--${size}` : 'functional-icon';

  const mainClasses = [mainClass, baseClassStr];
  if (!mainClasses.includes('functional-icon')) {
    mainClasses.push('functional-icon');
  }
  const mainClassStr = mainClasses.filter((s) => s !== '').join(' ');

  const backgroundClassStr = backgroundClass !== '' ? `${baseClassStr}__wrapper ${backgroundClass}` : `${baseClassStr}__wrapper`;
  const badgeLeftClassStr = badgeLeftClass !== '' ? `badge-left ${badgeLeftClass}` : '';
  const badgeRightClassStr = badgeRightClass !== '' ? `badge-right ${badgeRightClass}` : '';
  const labelBottomClassStr = labelBottomClass !== '' ? `label-bottom ${labelBottomClass}` : '';

  const isBadgeRightWithoutText = badgeRightText === '' && (badgeRightClass === 'up' || badgeRightClass === 'down');

  const badgeLeftHTML = badgeLeftText ? `<span class="${escapeHtml(badgeLeftClassStr)}">${escapeHtml(badgeLeftText)}</span>` : '';
  const badgeRightHTML = badgeRightText || isBadgeRightWithoutText ? `<span class="${escapeHtml(badgeRightClassStr)}">${escapeHtml(badgeRightText)}</span>` : '';
  const labelBottomHTML = labelBottomText ? `<span class="${escapeHtml(labelBottomClassStr)}">${escapeHtml(labelBottomText)}</span>` : '';

  const html = `<div class="${escapeHtml(mainClassStr)}">
  <div class="${escapeHtml(backgroundClassStr)}">
    ${badgeLeftHTML}
    ${badgeRightHTML}
    ${labelBottomHTML}
    <img src="${escapeHtml(imageURL)}" alt="${escapeHtml(altText)}" />
  </div>
</div>`;

  return url ? `<a href="${escapeHtml(url)}">${html}</a>` : html;
};

command.pad.complete_checker = (state, rankingName) => {
  state.md.helperScripts.add('https://kamigame.jp/kamigame-twitter-sharing/js/share-modal.js');
  state.md.helperScripts.add('https://kamigame.jp/vls-kamigame-gametool/js/pad-complete-checker/app.js');

  return `
  <div id="pad-complete-checker__button" class="pad-complete-checker__button" data-reference="${escapeHtml(rankingName)}"></div>`;
};

command.pad.tier_complete_checker = (state, tierName) => {
  state.md.helperScripts.add('https://kamigame.jp/kamigame-twitter-sharing/js/share-modal.js');
  state.md.helperScripts.add('https://storage.googleapis.com/vls-kamigame-gametool/js/puzzle-dragons/tier-complete-checker/app.js');

  return `
  <div class="tier-complete-checker__button" data-name="${escapeHtml(tierName)}"></div>`;
};

command.pad.monster_search = (state, item) => {
  if (item !== 'リーダースキル' && item !== 'スキル') {
    return '';
  }
  state.md.helperScripts.add('https://kamigame.jp/vls-kamigame-gametool/js/pad-monster-search/app.js');

  if (item === 'リーダースキル') {
    return `
    <div class="pad-monster-search-leader-skill"></div>
    `;
  }
  if (item === 'スキル') {
    return `
    <div class="pad-monster-search-skill"></div>
    `;
  }
};

command.pad.paddex = (_, ...args) => {
  const maybeJSONParse = (s) => {
    try {
      return JSON.parse(s);
    } catch (e) {
      console.error(e);
      return null;
    }
  };

  const parsed = maybeJSONParse(`[${args.map((arg) => (arg !== '' ? arg : '""')).join(',')}]`);
  if (parsed === null) {
    return '<div class="paddex"></div>';
  }

  const [mainElementIds, subElementIds, typeIds, awakenIds, activeSkillCategoryIds, leaderSkillCategoryIds] = parsed;
  const condition = { mainElementIds, subElementIds, typeIds, awakenIds, activeSkillCategoryIds, leaderSkillCategoryIds };

  return `<div class="paddex" data-condition="${escapeHtml(JSON.stringify(condition))}"></div>`;
};

command.pad.paddex_modal = (state, ...args) => {
  const maybeJSONParse = (s) => {
    try {
      return JSON.parse(s);
    } catch (e) {
      console.error(e);
      return null;
    }
  };

  const parsed = maybeJSONParse(`[${args.join(',')}]`);
  if (parsed === null) {
    return '<div class="paddex paddex-modal"></div>';
  }

  const [mainElementIds, subElementIds, typeIds, awakenIds, activeSkillCategoryIds, leaderSkillCategoryIds] = parsed;
  const condition = { mainElementIds, subElementIds, typeIds, awakenIds, activeSkillCategoryIds, leaderSkillCategoryIds };

  return `<div class="paddex paddex-modal" data-condition="${escapeHtml(JSON.stringify(condition))}"></div>`;
};

command.mhnow.skill_simulator = (state) => {
  state.md.helperScripts.add('https://kamigame.jp/vls-kamigame-gametool/js/mh-now-skill-simulator/app.js');

  return '<div id="mhnow-skillsim"></div>';
};

command.palworld.palindex_controller = (state) => {
  state.md.helperScripts.add('https://kamigame.jp/vls-kamigame-gametool/js/palworld-palindex/app.js');

  return '<div class="palindex-controller"></div>';
};

command.palworld.palbreed = (state, indexNo) => {
  state.md.helperScripts.add('https://kamigame.jp/vls-kamigame-gametool/js/palworld-palbreed/app.js');

  return `<div class="palbreed" data-index-no="${escapeHtml(indexNo || '0')}"></div>`;
};

command.general.user_ranking = (state, key) => {
  state.md.helperScripts.add('https://kamigame.jp/kamigame-twitter-sharing/js/share-modal.js');
  state.md.helperScripts.add('https://kamigame.jp/vls-kamigame-gametool/js/user-ranking/app.js');

  return `
  <div class="user-ranking" data-key="${escapeHtml(key)}"></div>
  <link href="https://kamigame.jp/vls-kamigame-gametool/js/user-ranking/app.css" rel="stylesheet" />
  `;
};

command.general.shindan_tool = (state, key) => {
  state.md.helperScripts.add('https://kamigame.jp/kamigame-twitter-sharing/js/share-modal.js');
  state.md.helperScripts.add('https://kamigame.jp/vls-kamigame-gametool/js/shindan-tool/app.js');

  return `<div class="shindan-tool" data-resource_key="${escapeHtml(key)}"></div>`;
};

command.general.ranking_enquete = (state, spreadsheetUrl, startAt, endAt, voteNum) => {
  state.md.helperScripts.add('https://kamigame.jp/lighthouse-ranking-enquete/js/ranking-enquete.js');

  return `
  <div class="ranking-enquete" data-spreadsheet-url="${escapeHtml(spreadsheetUrl)}" data-start-at="${escapeHtml(startAt)}" data-end-at="${escapeHtml(endAt)}" data-max-vote-num="${escapeHtml(voteNum)}"></div>
  <link href="https://kamigame.jp/lighthouse-ranking-enquete/js/ranking-enquete.css" rel="stylesheet" />
  `;
};

command.general.image_generator = (state, name) => {
  state.md.helperScripts.add('https://kamigame.jp/kamigame-twitter-sharing/js/share-modal.js');

  const game = state.env.game;
  return `<div class="image_generator" id="image_generator_wrapper" data-game="${escapeHtml(game)}" data-name="${escapeHtml(name)}"></div>`;
};

command.general.event_calendar = (state, mode, tweetText, shouldDisplayShareButtonStr, ...eventsArgs) => {
  state.md.helperScripts.add('https://kamigame.jp/vls-kamigame-gametool/js/event-calendar.js');

  const isTwoWeeklyMode = mode === 'twoWeekly';
  const shouldDisplayShareButton = shouldDisplayShareButtonStr === 'true';

  if (shouldDisplayShareButton) {
    state.md.helperScripts.add('https://kamigame.jp/kamigame-twitter-sharing/js/share-modal.js');
  }

  const eventsArgsStr = eventsArgs.join(',');
  const argPattern = /\[.+?\]/g;
  const ms = eventsArgsStr.match(argPattern);
  if (!ms) {
    return '';
  }

  const events = ms.map(m => {
    const args = m.slice(1, -1).split(',');
    const [id, name, start, end, eyecatch, url] = args;

    return { id, name, start, end, eyecatch, url };
  });

  const data = JSON.stringify({ shouldDisplayShareButton, tweetText, events });

  return `
  <div class="event-calendar" data-mode="${isTwoWeeklyMode ? 'twoWeekly' : 'monthly'}" data-events="${escapeHtml(data)}"></div>
  `;
};

command.general.rank_calculator = (state, key, contentName, formName, resultName) => {
  state.md.helperScripts.add('https://kamigame.jp/vls-kamigame-gametool/js/rank-calculator/app.js');
  return `
  <div class="rank-calculator" data-key="${escapeHtml(key)}" data-contentName="${escapeHtml(contentName)}" data-calculateFormName="${escapeHtml(formName)}" data-resultName="${escapeHtml(resultName)}"></div>
  `;
};

command.general.filter_table = (state, ...args) => {
  const maybeJSONParse = (s) => {
    try {
      return JSON.parse(s);
    } catch (e) {
      console.error(e);
      return null;
    }
  };

  const transformToFilterData = (type, dataOrTarget, target) => {
    // select, segment, label, imageLabel では第２引数にデータが入る
    // それ以外は第２引数にターゲットが入る

    if (type === 'select' || type === 'segment' || type === 'label' || type === 'andLabel') {
      return { filterData: { options: dataOrTarget }, target };
    }
    if (type === 'imageLabel' || type === 'andImageLabel') {
      return { filterData: { options: dataOrTarget.map(([value, url]) => ({ value, url })) }, target };
    }

    return { target: dataOrTarget };
  };

  const parsed = maybeJSONParse(`[${args.join(',')}]`);
  if (parsed === null) {
    return '';
  }

  const [parsedConfig, parsedRows] = parsed;
  if (!parsedConfig || !parsedRows || !Array.isArray(parsedConfig) || !Array.isArray(parsedRows)) {
    return '';
  }

  const configs = parsedConfig.map(([name, type, isDefault, dataOrTarget, target], index) => {
    const { filterData, target: transformedTarget } = transformToFilterData(type, dataOrTarget, target);
    const normalizedTarget = ['both', 'sort', 'filter'].includes(transformedTarget) ? transformedTarget : 'both';
    return { name, type, isDefault, filterData, index, target: normalizedTarget };
  });
  state.md.helperScripts.add('https://kamigame.jp/vls-kamigame-gametool/js/filter-table.js');

  return `
    <div class="filter-table-filter" data-configs="${escapeHtml(JSON.stringify(configs))}" data-rows="${escapeHtml(JSON.stringify(parsedRows))}"></div>
    `;
};

command.general.filter_image = (state, key, ...args) => {
  const maybeJSONParse = (s) => {
    try {
      return JSON.parse(s);
    } catch (e) {
      console.error(e);
      return null;
    }
  };

  const transformToFilterData = (type, dataOrTarget, target) => {
    // select, segment, label, imageLabel では第２引数にデータが入る
    // それ以外は第２引数にターゲットが入る

    if (type === 'select' || type === 'segment' || type === 'label' || type === 'andLabel') {
      return { filterData: { options: dataOrTarget }, target };
    }
    if (type === 'imageLabel' || type === 'andImageLabel') {
      return { filterData: { options: dataOrTarget.map(([value, url]) => ({ value, url })) }, target };
    }

    return { target: dataOrTarget };
  };

  const parsed = maybeJSONParse(`[${args.join(',')}]`);
  if (parsed === null) {
    return '';
  }

  const [parsedConfig, parsedItems] = parsed;
  if (!parsedConfig || !parsedItems || !Array.isArray(parsedConfig) || !Array.isArray(parsedItems)) {
    return '';
  }

  const configs = parsedConfig.map(([name, type, isDefault, dataOrTarget, target], index) => {
    const { filterData, target: transformedTarget } = transformToFilterData(type, dataOrTarget, target);
    const normalizedTarget = ['both', 'sort', 'filter'].includes(transformedTarget) ? transformedTarget : 'both';
    return { name, type, isDefault, filterData, index, target: normalizedTarget };
  });

  state.md.helperScripts.add('https://kamigame.jp/vls-kamigame-gametool/js/filter-image.js');

  return `
    <div class="filter-image-filter" data-key="${escapeHtml(key)}" data-configs="${escapeHtml(JSON.stringify(configs))}" data-items="${escapeHtml(JSON.stringify(parsedItems))}"></div>
  `;
};

command.general.fill_gage = (_, percentage, color = null) => {
  const styleColor = color ? `color:${escapeHtml(color)}; background-color:${escapeHtml(color)}` : '';
  return `
  <div class="fill_gage">
    <div class="filled" style="width:${escapeHtml(percentage)}%;${styleColor}"></div>
  </div>
  `;
};

command.general.count_up = (state, baseDate, prefix, suffix) => {
  state.md.helperScripts.add('https://kamigame.jp/vls-kamigame-gametool/js/updown-counter.js');

  const dataPrefix = prefix ? `data-prefix="${escapeHtml(prefix)}"` : '';
  const dataSuffix = suffix ? `data-suffix="${escapeHtml(suffix)}"` : '';

  return `
  <div class="updown-counter" data-mode="up" data-base-date="${escapeHtml(baseDate)}" ${dataPrefix} ${dataSuffix}></div>
  `;
};

command.general.count_down = (state, baseDate, fallbackText, prefix, suffix, emDate) => {
  state.md.helperScripts.add('https://kamigame.jp/vls-kamigame-gametool/js/updown-counter.js');

  const dataFallbackText = fallbackText ? `data-fallback-text="${escapeHtml(fallbackText)}"` : '';
  const dataPrefix = prefix ? `data-prefix="${escapeHtml(prefix)}"` : '';
  const dataSuffix = suffix ? `data-suffix="${escapeHtml(suffix)}"` : '';
  const dataEmDate = emDate ? `data-em-date="${escapeHtml(emDate)}"` : '';

  return `
  <div class="updown-counter" data-mode="down" data-base-date="${escapeHtml(baseDate)}" ${dataFallbackText} ${dataPrefix} ${dataSuffix} ${dataEmDate}></div>
  `;
};

/**
 * @param {*} state
 * @param {string} jsonUrl
 * @param {"searchable" | undefined} searchable
 * @param {string | undefined} forceZoom
 * @param {string[]} args
 * @returns {string}
 */
command.general.kamigame_map = (state, jsonUrl, searchable, forceZoom, ...args) => {
  state.md.helperScripts.add('https://storage.googleapis.com/ls-kamigame-map/embedded-map-client/main.js');

  const maybeJSONParse = (s) => {
    try {
      return JSON.parse(s);
    } catch (e) {
      return [];
    }
  };

  const attrs = [];
  attrs.push(`data-is-searchable="${searchable === 'searchable'}"`);

  if (typeof forceZoom !== 'undefined' && !Number.isNaN(parseFloat(forceZoom))) {
    attrs.push(`data-force-zoom="${escapeHtml(forceZoom)}"`);
  }

  if (args.length > 0) {
    const parsed = maybeJSONParse(`[${args.join(',')}]`);

    const visibleCatagoryIds = parsed[0];
    if (visibleCatagoryIds && visibleCatagoryIds.length > 0) {
      attrs.push(`data-visible-category-ids=${escapeHtml(JSON.stringify(visibleCatagoryIds))}`);
    }

    const centerPos = parsed[1];
    if (centerPos && centerPos.length === 2) {
      const [x, y] = centerPos;
      attrs.push(`data-center-pos=${escapeHtml(JSON.stringify({ x, y }))}`);
    }
  }

  return `
  <div class="kamigame-map-root-class" data-json-url="${escapeHtml(jsonUrl)}" ${attrs.join(' ')}></div>
  <link href="https://storage.googleapis.com/ls-kamigame-map/embedded-map-client/main.css" rel="stylesheet" />
  `;
};

command.general.gacha = (state, id, name, tweet_text, buttons = ['1', '10']) => {
  const game = state.env.game;
  const richGachaAvailableGames = ['fgo'];
  if (richGachaAvailableGames.includes(game)) {
    const scriptPrefix = `/js/${escapeHtml(encodeURIComponent(game))}`;
    state.md.helperScripts.add(`${scriptPrefix}/vendor.bundle.js`);
    state.md.helperScripts.add(`${scriptPrefix}/bundle.js`);
  }
  state.md.helperScripts.add('https://storage.googleapis.com/kamigame-twitter-sharing/js/share-modal.js');
  return `<div class="gacha_simulator" id="gacha_wrapper" data-id="${escapeHtml(id)}" data-name="${escapeHtml(name)}" data-tweet-text="${escapeHtml(tweet_text || '')}" data-buttons="${escapeHtml(JSON.stringify(buttons))}"></div>`;
};
command.general.single_gacha = (...args) => command.general.gacha(...args, ['1']);
command.general.ten_times_gacha = (...args) => command.general.gacha(...args, ['10']);
command.general.eleven_times_single_gacha = (...args) => command.general.gacha(...args, ['1', '11']);
command.general.twenty_times_gacha = (...args) => command.general.gacha(...args, ['20']);
command.general.fifty_times_gacha = (...args) => command.general.gacha(...args, ['50']);
command.general.thirty_times_gacha = (...args) => command.general.gacha(...args, ['30']);
command.general.fifty_five_times_gacha = (...args) => command.general.gacha(...args, ['55']);
command.general.sixty_six_times_gacha = (...args) => command.general.gacha(...args, ['66']);
command.general.seventy_seven_times_gacha = (...args) => command.general.gacha(...args, ['77']);

command.general.gacha_target_mode = (state, id, name, max, type, tweet_text) => {
  const game = state.env.game;
  const richTargetGachaAvailableGames = ['fgo'];
  if (richTargetGachaAvailableGames.includes(game)) {
    const scriptPrefix = `/js/${escapeHtml(encodeURIComponent(game))}`;
    state.md.helperScripts.add(`${scriptPrefix}/vendor.bundle.js`);
    state.md.helperScripts.add(`${scriptPrefix}/bundle.js`);
  }

  return `<div class="target_gacha_simulator" id="target_gacha_wrapper" data-id="${escapeHtml(id)}" data-name="${escapeHtml(name)}" data-max="${escapeHtml(max)}" data-type="${escapeHtml(type)}" data-tweet-text="${escapeHtml(tweet_text || '')}"><div id="target_gacha_${escapeHtml(type)}"></div></div>`;
};

command.mhrise.material_simulator = (state) => {
  return '<div class="material-simulator"><img class="loading-indicator" src="/img/loading.gif" /></div>';
};

command.brodus.pickup_gacha = (_, id, name, tweet_text, buttons = ['1', '10']) => {
  return `<div class="pickup_gacha_simulator" id="gacha_wrapper" data-id="${escapeHtml(id)}" data-name="${escapeHtml(name)}" data-tweet-text="${escapeHtml(tweet_text || '')}" data-buttons="${escapeHtml(JSON.stringify(buttons))}"></div>`;
};

command.general.cpi_adsense_animation = (_, link, viewableLink, src, spriteImageSrc) => {
  const scriptUrl = 'https://x-storage.cir.io/animation/v1/circuit_x_animation.js';
  const spriteImageSrcFileName = spriteImageSrc.match('.+/(.+?).[a-z]+([?#;].*)?$')[1];
  const [, width, height, spriteFps] = spriteImageSrcFileName.split('_');

  const settingJson = {
    link, viewableLink, src, spriteImageSrc, spriteFps, width, height,
  };

  return `<script src="${escapeHtml(scriptUrl)}" data-circuit-x-animation-params='${escapeHtml(JSON.stringify(settingJson))}'></script>`;
};

command.general.radar_chart = (_, ...args) => {
  return `<div class="radar-chart"><canvas data-values="${escapeHtml(JSON.stringify(args))}"></canvas></div>`;
};

command.general.copy_me = (_, text) => {
  // DOM の ID として無効な数字始まりになるのを防ぐためにプレフィックスを付ける
  const randomId = `copyme${Math.random().toString(32).substring(2)}`;
  return `<div class="copyme"><input id="${escapeHtml(randomId)}" value="${escapeHtml(text)}" readonly><button class="copy-clipboard" data-clipboard-target="#${escapeHtml(randomId)}"><img src="/img/clipboard.svg" alt="クリップボードにコピー"></button></div>`;
};

command.general.copy_and_save = (state, placeHolder, storageKey) => {
  state.md.helperScripts.add('https://kamigame.jp/vls-kamigame-gametool/js/general/copy-and-save/main.js');
  return `<div id="copy-and-save" data-place-holder="${escapeHtml(placeHolder)}" data-storage-key="${escapeHtml(storageKey)}"></div>`;
};

command.general.copy_with_newline = (state, text) => {
  state.md.helperScripts.add('https://kamigame.jp/vls-kamigame-gametool/js/general/copy-with-newline/main.js');
  return `<div id="copy-with-newline" data-text="${escapeHtml(text)}"></div>`;
};

command.general.seinou_hikaku = (state, resourceKey, defaultEntityGroupName, defaultEntityIdsText, backgroundColor, textColor, borderColor) => {
  state.md.helperScripts.add('https://kamigame.jp/vls-kamigame-gametool/js/seinou-hikaku.js');
  return `<div class="seinou-hikaku" data-resource_key="${escapeHtml(resourceKey)}" data-default_entity_group_name="${escapeHtml(defaultEntityGroupName)}" data-default_entity_ids_text="${escapeHtml(defaultEntityIdsText)}" data-background_color="${escapeHtml(backgroundColor || '')}" data-text_color="${escapeHtml(textColor || '')}" data-border_color="${escapeHtml(borderColor || '')}"></div>`;
};

command.general.umamusume_friends = (state, id) => {
  state.md.helperScripts.add('https://storage.googleapis.com/hotchpotch/js/umamusume-friends/app.js');
  const supportCardIdAttr = id ? `data-support-card-id="${escapeHtml(id)}"` : '';

  // div#kg_no_comment コメント欄を非表示とマークする
  // https://app.asana.com/0/1204456723859882/1205017393325948/f
  return `<div class="umamusume-friends" ${supportCardIdAttr}></div><div id="kg_no_comment"></div>`;
};

command.general.pd_party = (state, dungeonId, characterId) => {
  state.md.helperScripts.add('https://storage.googleapis.com/hotchpotch/js/pd-party/main.js');
  const dungeonAttr = dungeonId ? `data-dungeon-id="${escapeHtml(dungeonId)}"` : '';
  const characterAttr = characterId ? `data-character-id="${escapeHtml(characterId)}"` : '';

  // div#kg_no_comment コメント欄を非表示とマークする
  // https://app.asana.com/0/1204456723859882/1205017393325948/f
  return `<div id="kg-pd-party" ${dungeonAttr} ${characterAttr}></div><div id="kg_no_comment"></div>`;
};

command.general.ffviiec_friends = (state) => {
  state.md.helperScripts.add('https://storage.googleapis.com/hotchpotch/js/ff7ec-friends/main.js');
  // div#kg_no_comment コメント欄を非表示とマークする
  // https://app.asana.com/0/1204456723859882/1205017393325948/f
  return '<div id="ff7ec-friends"></div><div id="kg_no_comment"></div>';
};

command.general.pd_friends = (state, characterId) => {
  state.md.helperScripts.add('https://storage.googleapis.com/hotchpotch/js/pd-friends/main.js');
  const characterAttr = characterId ? `data-character-id="${escapeHtml(characterId)}"` : '';

  // div#kg_no_comment コメント欄を非表示とマークする
  // https://app.asana.com/0/1204456723859882/1205017393325948/f
  return `<div id="kg-pd-friends" ${characterAttr}></div><div id="kg_no_comment"></div>`;
};

command.general.guraburu_party = (state, bossId) => {
  state.md.helperScripts.add('https://storage.googleapis.com/hotchpotch/js/guraburu-party/main.js?20210901');
  const bossAttr = bossId ? `data-boss-id="${escapeHtml(bossId)}"` : '';
  // div#kg_no_comment コメント欄を非表示とマークする
  // https://app.asana.com/0/1204456723859882/1205017393325948/f
  return `<div id="kg-guraburu-party" ${bossAttr}></div><div id="kg_no_comment"></div>`;
};

command.general.mhnow_referrals = (state) => {
  state.md.helperScripts.add('https://storage.googleapis.com/hotchpotch/js/mhnow-referrals/main.js');
  // div#kg_no_comment コメント欄を非表示とマークする
  // https://app.asana.com/0/1204456723859882/1205017393325948/f
  return '<div id="mhnow-referrals"></div><div id="kg_no_comment"></div>';
};

command.general.clipboard_copy_bbs = (state, group, label) => {
  state.md.helperScripts.add('https://storage.googleapis.com/hotchpotch/js/clipboard-copy/main.js');
  return `<div id="clipboard-copy" data-group="${escapeHtml(group)}" data-label="${escapeHtml(label)}"></div><div id="kg_no_comment"></div>`;
};

command.general.dokkan_battle_party = (state, toolId) => {
  state.md.helperScripts.add('https://storage.googleapis.com/hotchpotch/js/dokkan-battle-party/main.js');
  return `<div id="kg-dokkan-battle-party" data-tool-id="${escapeHtml(toolId)}"></div>`;
};

command.general.genshin_team = (state, characterId, categoryId, spiralAbyssFlag) => {
  state.md.helperScripts.add('https://storage.googleapis.com/hotchpotch/js/genshin-team/main.js');

  const characterIdAttr = characterId ? `data-character-id="${escapeHtml(characterId)}"` : '';
  const categoryIdAttr = categoryId ? `data-category-id="${escapeHtml(categoryId)}"` : '';
  const spiralAbyssFlagAttr = ['true', 'false'].includes(spiralAbyssFlag) ? `data-is-spiral-abyss="${escapeHtml(spiralAbyssFlag)}"` : '';

  const attr = [characterIdAttr, categoryIdAttr, spiralAbyssFlagAttr].filter((attr) => attr !== '').join(' ');

  return `<div id="genshin-team" ${attr}></div>`;
};

command.general.genshin_friend = (state) => {
  state.md.helperScripts.add('https://storage.googleapis.com/hotchpotch/js/genshin-friends/main.js');
  return '<div id="genshin-friends"></div>';
};

command.general.layer_text_table_image = (_, linkURL, layerText, imageURL, altText) => {
  const attrs =
    linkURL.startsWith('https://kamigame.jp') || linkURL.startsWith('http://kamigame.jp') || linkURL.startsWith('https://gamevillage.net') || linkURL.startsWith('http://gamevillage.net') || linkURL.startsWith('/')
      ? ''
      : 'target="_blank" rel="noopener nofollow"';
  return `<a href="${escapeHtml(linkURL)}" ${attrs}><img src="${escapeHtml(imageURL)}" alt="${escapeHtml(altText)}" loading="lazy"><span class="layer_text">${escapeHtml(layerText)}</span></a>`;
};

command.general.user_saiten = (state, wikiPath, group, entity, version, ...args) => {
  state.md.helperScripts.add(
    'https://kamigame.jp/vls-kamigame-gametool/js/user-saiten/main.js'
  );

  const mode = args[0];
  const groupWithWikiPath = `${wikiPath}_${group}`;

  if (mode === 'saiten') {
    return `<div class="user-saiten-tool" data-group="${escapeHtml(groupWithWikiPath)}" data-entity="${escapeHtml(
      entity
    )}" data-version="${escapeHtml(version)}" data-mode="${escapeHtml(mode)}" ></div>`;
  }

  if (mode === 'tensu') {
    const saitenKoumoku = args[1];
    return `<span class="user-saiten-tool" data-group="${escapeHtml(groupWithWikiPath)}" data-entity="${escapeHtml(
      entity
    )}" data-version="${escapeHtml(version)}" data-mode="${escapeHtml(mode)}" data-saiten-koumoku=${escapeHtml(
      saitenKoumoku
    )}></span>`;
  }

  if (mode === 'compact-saiten') {
    const saitenKoumoku = args[1];
    return `<span class="user-saiten-tool" data-group="${escapeHtml(groupWithWikiPath)}" data-entity="${escapeHtml(
      entity
    )}" data-version="${escapeHtml(version)}" data-mode="${escapeHtml(mode)}" data-saiten-koumoku=${escapeHtml(
      saitenKoumoku
    )}></span>`;
  }
};

command.general.mhwilds_derivation_table = (state, hash) => {
  state.md.helperScripts.add('https://kamigame.jp/vls-kamigame-gametool/js/mhwilds-derivation-table/app.js');
  return `<div class="mhwilds_weapon_lineage_list_table" data-key="${escapeHtml(hash)}"></div>`;
};

command.general.storeranking_sales_ranking_list = (state, title, img, appStoreId, googlePlayId) => {
  state.md.helperScripts.add(
    'https://kamigame.jp/kamigame-storeranking-front/js/store-ranking/main.js'
  );

  return `<div id="storeranking-sales-ranking-list" data-game-title="${escapeHtml(title)}" data-img="${escapeHtml(img)}" data-appstore-id="${escapeHtml(appStoreId)}" data-googleplay-id="${escapeHtml(googlePlayId)}"></div>`;
};

command.general.storeranking_daily_ranking_transition = (state, appStoreId, googlePlayId) => {
  state.md.helperScripts.add(
    'https://kamigame.jp/kamigame-storeranking-front/js/store-ranking/main.js'
  );

  return `<div id="storeranking-daily-ranking-transition" data-appstore-id="${escapeHtml(appStoreId)}" data-googleplay-id="${escapeHtml(googlePlayId)}"></div>`;
};

command.general.storeranking_monthly_ranking_transition = (state, appStoreId, googlePlayId) => {
  state.md.helperScripts.add(
    'https://kamigame.jp/kamigame-storeranking-front/js/store-ranking/main.js'
  );

  return `<div id="storeranking-monthly-ranking-transition" data-appstore-id="${escapeHtml(appStoreId)}" data-googleplay-id="${escapeHtml(googlePlayId)}"></div>`;
};

command.general.no_comment = (state, id) => {
  // div#kg_no_comment コメント欄を非表示とマークする
  // https://app.asana.com/0/1204456723859882/1205017393325948/f
  return '<div id="kg_no_comment"></div>';
};

command.general.event_notification = () => {
  return '<div class="event-notification"></div>';
};

command.usum.radar_chart = (_, ...args) => {
  return `<div class="usum_radar_chart"><canvas data-values="${escapeHtml(JSON.stringify(args))}"></canvas></div>`;
};

command.mhxx.sharpness_gage = (_, veryBad, bad, medium, good, veryGood, great, excellent, brilliant) => {
  // see also https://trello.com/c/6eoWcE5V/4037-mhx#comment-58bfb7bf58854d0fb9764638
  const max = 102;
  const rate = 3;

  let total = 0;

  const levelMap = new Map([
    ['very_bad', veryBad],
    ['bad', bad],
    ['medium', medium],
    ['good', good],
    ['very_good', veryGood],
    ['great', great],
    ['excellent', excellent],
    ['brilliant', brilliant],
  ]);

  let result = '';
  levelMap.forEach((value, key) => {
    const intValue = parseInt(((!!value) ? value : 0), 10);
    const displayValue = parseInt(intValue / rate, 10);
    if (displayValue <= 0) {
      return;
    }

    total += intValue;
    result += `<span class="${escapeHtml(key)}">${'-'.repeat(displayValue)}</span>`;
  });

  if (max > total) {
    result += `<span class="empty">${'-'.repeat(parseInt((max - total) / rate, 10))}</span>`;
  }

  return `<span class="sharpness_gage">${result}</span>`;
};

command.shironeko_project.character_top_image = (_, normal, awake) => {
  if (!normal && !awake) {
    return '';
  }

  let normalImageArea = '';
  let awakeImageArea = '';
  let awakeImageNotation = '';

  if (normal) {
    normalImageArea = `<li><img src="${escapeHtml(normal)}" alt="キャラクタートップ画像"></li>`;
  }

  if (awake) {
    awakeImageArea = `<li class="awake_image"><a href="#" onclick="document.getElementById('character_top_image').getElementsByClassName('awake_image_object')[0].style.visibility = 'inherit'; return false;"><img class="awake_image_object" src="${escapeHtml(awake)}" alt="キャラクター覚醒絵"></a></li>`;
    awakeImageNotation = '<p>※ネタバレ防止のため、覚醒絵は非表示にしています。</p>';
  }

  return `<ul id="character_top_image">${normalImageArea}${awakeImageArea}</ul>${awakeImageNotation}`;
};

command.letsgo.radar_chart = (_, ...args) => {
  return `<div class="letsgo_radar_chart"><canvas data-values="${escapeHtml(JSON.stringify(args))}"></canvas></div>`;
};

command.eldenring.build_simulator = (state) => {
  state.md.helperScripts.add('https://kamigame.jp/vls-kamigame-gametool/js/eldenring/build-simulator/main.js');

  return '<div id="elden-ring-build-simulator-id"></div>';
};

command.dokkan_battle.link_compatibility_checker = (state, characterId) => {
  state.md.helperScripts.add(
    'https://kamigame.jp/vls-kamigame-gametool/js/dokkan-battle/link-compatibility-checker/main.js'
  );

  return `<div id="link-compatibility-checker" data-character-id="${escapeHtml(characterId)}"></div>`;
};

// 以下の image_with_detail は汎用化を目指して作成しましたが、あまり良い方法ではなかったので要検討
// REF: https://github.com/voyagegroup/lighthouse-studio/issues/3132#issuecomment-1144466725
const cardWithDetailMonsterFunction = (_, imageSrc, imageClass, detailContainerId, title, cardType, level, rarity, attribute, atk, def, description, pageDetailUrl, race, roles, limit, pendulumScale, pendulumDescription) => {
  const dataImageSrc = `data-image-src="${escapeHtml(imageSrc)}"`;
  const dataDetailContainerId = `data-detail-container-id="${escapeHtml(detailContainerId)}"`;
  const dataTitle = `data-title="${escapeHtml(title)}"`;

  const options = {};
  options.cardType = cardType;
  options.level = level;
  options.rarity = rarity;
  options.attribute = attribute;
  options.atk = atk;
  options.def = def;
  options.description = description;
  options.pageDetailUrl = pageDetailUrl;
  options.race = race;
  options.roles = roles.split('\\n');
  options.limit = limit || '';
  options.pendulumScale = pendulumScale || '';
  options.pendulumDescription = pendulumDescription || '';

  const dataOptions = `data-options="${escapeHtml(JSON.stringify(options))}"`;

  return `
  <div class="${escapeHtml(imageClass)} image-with-detail-img-wrapper">
    <img class="image-with-detail-img" src="${escapeHtml(imageSrc)}" alt="${escapeHtml(title)}" ${dataImageSrc} ${dataDetailContainerId} ${dataTitle} ${dataOptions}></img>
  </div>`;
};

const cardWithDetailSpellOrTrapFunction = (_, imageSrc, imageClass, detailContainerId, title, cardType, type, rarity, description, pageDetailUrl, limit) => {
  const dataImageSrc = `data-image-src="${escapeHtml(imageSrc)}"`;
  const dataDetailContainerId = `data-detail-container-id="${escapeHtml(detailContainerId)}"`;
  const dataTitle = `data-title="${escapeHtml(title)}"`;

  const options = {};
  options.cardType = cardType;
  options.type = type;
  options.rarity = rarity;
  options.description = description;
  options.pageDetailUrl = pageDetailUrl;
  options.limit = limit || '';

  const dataOptions = `data-options="${escapeHtml(JSON.stringify(options))}"`;

  return `
  <div class="${escapeHtml(imageClass)} image-with-detail-img-wrapper">
    <img class="image-with-detail-img" src="${escapeHtml(imageSrc)}" alt="${escapeHtml(title)}" ${dataImageSrc} ${dataDetailContainerId} ${dataTitle} ${dataOptions}></img>
  </div>`;
};

const cardWithDetailDisplayFunction = (_, id) => {
  return `<div id="${escapeHtml(id)}" class="image-with-detail-detail-container-class" data-type="yugioh-card"></div>`;
};

command.masterduel.card_with_detail_monster = cardWithDetailMonsterFunction;
command.duellinks.card_with_detail_monster = cardWithDetailMonsterFunction;
command.masterduel.card_with_detail_spell_or_trap = cardWithDetailSpellOrTrapFunction;
command.duellinks.card_with_detail_spell_or_trap = cardWithDetailSpellOrTrapFunction;
command.masterduel.card_with_detail_display = cardWithDetailDisplayFunction;
command.duellinks.card_with_detail_display = cardWithDetailDisplayFunction;


module.exports = function kamigameCommand(md) {
  const expectOpener = '{';
  const expectCloser = '}';

  /**
   * Unescape Markdown text
   *
   * Original code (MIT License):
   *   https://github.com/markdown-it/markdown-it/blob/2b6cac25823af011ff3bc7628bc9b06e483c5a08/lib/common/utils.js
   *
   * Copyright (c) 2014 Vitaly Puzrin, Alex Kocharin.
   *
   * Permission is hereby granted, free of charge, to any person
   * obtaining a copy of this software and associated documentation
   * files (the "Software"), to deal in the Software without
   * restriction, including without limitation the rights to use,
   * copy, modify, merge, publish, distribute, sublicense, and/or sell
   * copies of the Software, and to permit persons to whom the
   * Software is furnished to do so, subject to the following
   * conditions:
   *
   * The above copyright notice and this permission notice shall be
   * included in all copies or substantial portions of the Software.
   *
   * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
   * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
   * OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
   * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
   * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
   * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
   * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
   * OTHER DEALINGS IN THE SOFTWARE.
   */
  const UNESCAPE_MD_RE = /\\([!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~])/g;
  function unescapeMd(str) {
    if (str.indexOf('\\') < 0) { return str; }
    return str.replace(UNESCAPE_MD_RE, '$1');
  }

  function executeCommandString(state, commandString) {
    let matched;
    // eslint-disable-next-line no-cond-assign
    if ((matched = commandMatcher.exec(commandString)) === null) {
      return false;
    }

    const [commandNamespace, commandName, commandArgs] = [matched[1], matched[2], matched[3]];
    if (!command[commandNamespace] || !command[commandNamespace][commandName]) {
      return false;
    }

    const escapedComma = '____ESCAPED_COMMA____';
    const escapedCommandArgs = commandArgs.replace(/\\,/g, escapedComma);
    const commandResult = command[commandNamespace][commandName](state, ...((escapedCommandArgs.split(',')).map((v) => unescapeMd(v).replace(new RegExp(escapedComma, 'g'), ',').trim())));
    if (commandResult === false) {
      return false;
    }

    return commandResult;
  }

  md.block.ruler.before('paragraph', 'kamigame_command', function replace(state, startLine, endLine, silent) {
    if (silent) {
      false;
    }

    const start = state.bMarks[startLine] + state.tShift[startLine];
    const end = state.eMarks[startLine];
    let closerPos;

    if (state.src.charAt(start) !== expectOpener) {
      return false;
    }

    for (let pos = start; pos < end; pos++) {
      if (state.src.charAt(pos) === expectCloser) {
        closerPos = pos;
        break;
      }
    }

    if (!closerPos) {
      return false;
    }

    const markup = state.src.substr(start, closerPos - start + 1);
    const commandResult = executeCommandString(state, markup);
    if (!commandResult) {
      return false;
    }

    const token = state.push('html_block', '', 0);
    token.content = commandResult;
    token.block = true;

    state.line = startLine + 1;

    return true;
  });

  md.inline.ruler.push('kamigame_command_inline', function replace(state, silent) {
    if (silent) {
      return false;
    }

    const start = state.pos;
    const max = state.posMax;

    if (state.src.charAt(start) !== expectOpener) {
      return false;
    }

    let closerPos;
    for (let pos = start; pos < max; pos++) {
      if (state.src.charAt(pos) === expectCloser) {
        closerPos = pos;
        break;
      }
    }

    if (!closerPos) {
      return false;
    }

    const markup = state.src.substr(start, closerPos + expectCloser.length);
    const commandResult = executeCommandString(state, markup);
    if (!commandResult) {
      return false;
    }

    const token = state.push('html_block', '', 0);
    token.content = commandResult;
    token.block = true;

    state.pos = closerPos + expectCloser.length;
    state.posMax = max;

    return true;
  });
};
